import React from "react";
import { Reveal, SectionHeading } from "./_shared";
import { EVENT_CONFIG } from "../../config/event";

const items = [
    { title: "Perché nasce SafetyDesk81", text: "Le esigenze che hanno portato alla realizzazione della piattaforma.", time: EVENT_CONFIG.EVENT_PRESENTATION_TIME },
    { title: "Dimostrazione della piattaforma", text: "Una panoramica completa delle principali sezioni.", time: null },
    { title: "Chatbot e agente AI", text: "Come interrogare la piattaforma e farsi supportare nella gestione quotidiana.", time: null },
    { title: "Registri e dossier digitali", text: "Come funziona il Dossier ASL e la digitalizzazione dei registri aziendali.", time: null },
    { title: "Esempi di utilizzo in azienda", text: "Come organizzare aziende, lavoratori, scadenze e adempimenti.", time: null },
    { title: "Domande e confronto", text: "Uno spazio dedicato alle domande dei partecipanti.", time: null },
];

export default function Program() {
    return (
        <section id="programma" className="py-24 md:py-32 bg-white">
            <div className="max-w-[1400px] mx-auto px-5 md:px-8">
                <SectionHeading chapter={8} chapterLabel="Programma indicativo" title="Cosa vedrai durante l'evento." />
                <Reveal delay={0.15}>
                    <div className="mt-6 flex flex-wrap gap-4 items-baseline max-w-2xl">
                        <p className="text-navy-600 text-lg leading-relaxed">
                            <strong className="text-navy-950">Giovedì 1 ottobre 2026</strong> — {EVENT_CONFIG.EVENT_ADDRESS}.
                        </p>
                        <div className="flex flex-wrap gap-2 text-[11px] font-mono uppercase tracking-widest">
                            <span className="px-3 py-1 rounded-full bg-navy-50 text-navy-700">{EVENT_CONFIG.EVENT_APERITIVO_TIME} · Aperitivo</span>
                            <span className="px-3 py-1 rounded-full bg-gold-100 text-gold-700 font-bold">{EVENT_CONFIG.EVENT_PRESENTATION_TIME} · Presentazione</span>
                            <span className="px-3 py-1 rounded-full bg-navy-50 text-navy-700">{EVENT_CONFIG.EVENT_DINNER_TIME} · Cena a buffet</span>
                        </div>
                    </div>
                </Reveal>

                <div className="mt-14 relative">
                    <div aria-hidden className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-navy-100 md:-translate-x-1/2" />
                    <ul className="space-y-8 md:space-y-14">
                        {items.map((it, i) => {
                            const right = i % 2 === 1;
                            return (
                                <li key={it.title} className="relative">
                                    <Reveal delay={i * 0.06}>
                                        <div className={`flex flex-col md:flex-row md:items-center gap-4 ${right ? "md:flex-row-reverse" : ""}`}>
                                            <div className="md:w-1/2 pl-16 md:pl-0 md:px-8">
                                                <div className="chapter-chip mb-3"><span className="num">{`0${i + 1}`}</span><span className="text-navy-400">Momento</span></div>
                                                <h3 className="font-display font-bold text-navy-950 text-2xl md:text-3xl leading-snug">{it.title}</h3>
                                                <p className="mt-3 text-navy-600 leading-relaxed">{it.text}</p>
                                            </div>
                                            <div className="md:w-1/2" />
                                        </div>
                                        <div className={`absolute left-6 md:left-1/2 top-0 md:top-1/2 md:-translate-y-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-gold-400 ring-4 ring-white`} />
                                    </Reveal>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
}
